import { NeuCard } from "../neu/Neu";

// جدول بيانات: صفوف على الشاشة الكبيرة وبطاقات على الجوال، بنفس الأعمدة.
export const DataTable = ({ columns, rows, rowKey, onRowClick, empty, testid = "data-table" }) => {
  if (!rows.length) {
    return (
      <NeuCard className="p-8 text-center" data-testid={`${testid}-empty`}>
        <p className="text-sm text-muted-foreground">{empty}</p>
      </NeuCard>
    );
  }

  return (
    <NeuCard className="p-0" data-testid={testid}>
      <div className="hidden overflow-x-auto sm:block">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border/60 text-[11px] font-bold text-muted-foreground">
              {columns.map((col) => (
                <th key={col.key} className="px-4 py-3 text-start whitespace-nowrap">{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={rowKey(row)} data-testid={`${testid}-row-${rowKey(row)}`}
                  className="border-b border-border/40 transition-colors last:border-0 hover:bg-primary/5">
                {columns.map((col) => (
                  <td key={col.key}
                      className={`px-4 py-3 align-middle ${col.cellClass || ""} ${
                        col.key === "actions" ? "" : "cursor-pointer"}`}
                      onClick={col.key === "actions" ? undefined : () => onRowClick?.(row)}>
                    {col.render(row)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="grid gap-2 p-3 sm:hidden">
        {rows.map((row) => (
          <div key={rowKey(row)} data-testid={`${testid}-card-${rowKey(row)}`}
               className="grid gap-2 rounded-2xl p-3 shadow-neu-in">
            {columns.map((col) => (
              <div key={col.key} className="flex items-center justify-between gap-3">
                <span className="text-[11px] font-bold text-muted-foreground">{col.label}</span>
                <span className="min-w-0 truncate text-end"
                      onClick={col.key === "actions" ? undefined : () => onRowClick?.(row)}>
                  {col.render(row)}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </NeuCard>
  );
};
